import AboutMain from 'AboutComponents/AboutMain';
import Footer from 'Compnents2/Footer';
import Header from 'Compnents2/Header';
import MobileMenu from 'Compnents2/MobileMenu';
import React from 'react';

function About() {
  return (
      <div id='About'>
          <AboutMain/>
          <Footer/>
      </div>
  );
}

export default About;
